import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackCheckbox from "../Input/FeedbackCheckBox";
import FeedbackText from "../Input/FeedbackText";

import { ErrorMessage } from "./ErrorMessage";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question10FlashCoachExperience = ({
  accessibilityFactors,
  accessibilityFactorsOthers,
  updateSelectionFormData,
  updateFormData,
  onEnterKeyPress,
  validationError,
  conditionalInputError,
}) => {
  const othersCheckboxIsFilled = accessibilityFactors.filter(
    item => item.id === "5" && item.checked
  );

  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={
            "Share with us the factors that directly influenced your rating.*"
          }
        />
        <FeedbackCheckbox
          inputID={"accessibilityFactors"}
          checkBoxList={accessibilityFactors}
          updateSelectionFormData={updateSelectionFormData}
        />
        {(conditionalInputError?.action === "SHOW_TEXT_INPUT" ||
          othersCheckboxIsFilled.length > 0) && (
          <FeedbackText
            inputID={"accessibilityFactorsOthers"}
            inputText={accessibilityFactorsOthers}
            updateFormData={updateFormData}
            onEnterKeyPress={onEnterKeyPress}
            placeHolder={"Please specify: _____"}
          />
        )}
        {validationError?.error && (
          <ErrorMessage text={validationError.error} />
        )}
      </FeedbackFormLayout>
    </>
  );
};
